import {UserManagement} from "@/api/modules/userManagement/UserManagement";
import {StoreProxy} from "@/api/common/StoreProxy";
import {DealerManagement} from "@/api/modules/dealerManagement/DealerManagement";
import {required} from "vuelidate/lib/validators";

export default {
    name: "CreateDealer",
    data() {
        return {
            dealer: '',
            company: '',
            homeBranch: '',
            companies: [],
            branches: [],
            accountExists: false,
            error: false
        }
    },
    validations: {
        dealer: {
            required
        },
        company: {
            required
        },
        homeBranch: {
            required
        }
    },
    created(){

        this._auth = StoreProxy.getAuth(this.$store);
        this._userManagement = new UserManagement(this._auth);
        this._dealerManagement = new DealerManagement(this._auth);

        let vm = this;
        this._userManagement.getCompanies().then(companies => {

            companies.forEach(function(company){
              vm.companies.push(company);
            });

        }).catch(e => {

            this.$notify.error({
                title: 'Internal Error',
                message: 'Error loading companies'
            });

            this.companies = [];

        });


    },
    mounted() {
        window.tracer.verbose("[v980856-ADM] CreateDealer component mounted.");

    },
    beforeDestroy() {
        window.tracer.verbose("[v673031-ADM] CreateDealer component destroyed.");
    },
    methods: {
        checkDealer(){

            window.tracer.verbose("[v529487-ADM] checkDealer() invoked.");


            if ((!this.dealer) || this.dealer.length == 0)
            {
                window.tracer.debug("[d260899-ADM] Nothing to check. value is empty");
                return;
            }

            let account = this.dealer.toUpperCase();

            let vm = this;
            this._dealerManagement.existAccount(account.toUpperCase()).then((exists) => {

                if (exists) {
                    vm.accountExists = true;
                    vm.error = true;
                    vm.dealer = account;
                }
                else{
                    vm.accountExists = false;
                    vm.error = false;
                    vm.dealer = account;
                }

            }).catch(e => {

                window.tracer.error(e);
                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Error checking if account already exists in the system.'
                });
            });

        },
        companySelected(companyId){

            if (companyId == null || companyId.length === 0){
                window.tracer.warn("[w626477-ADM] companyId argument is an invalid. Error will be thrown.");
                throw new Error("[e709732-ADM] companyId is empty string. Invalid value");
            }

            this._userManagement.getCompanyBranches(companyId).then(branches => {
                    if (branches != null) {
                        this.branches = branches;
                    }
                    else{
                        this.branches = [];
                    }
                }
            ).catch(error => {
                if (error != null){
                    console.error(error);
                }

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Unable to load companies branches. Try again later.'
                });

                this.branches = [];
            });
        },
        onCancel(){
            this.dealer = '';
            this.company= '';
            this.homeBranch = '';
            this.$emit('cancel');
        },
        onSubmit(){

            window.tracer.verbose("[v955418-ADM] onSubmit() clicked");
            this.$v.$touch();

            if (this.error){
                window.tracer.verbose("[v891293-ADM] Form has an validation error. Exit.");

                return;
            }

            if (this.$v.$invalid){
                this.error = true;
                window.tracer.debug("[d900985-ADM] Form has validation error. Possible missing required fields.");
                return;
            }

            try{

                this.error = false;


                this._dealerManagement.createDealer(this.dealer, this.homeBranch, this.company).then(() => {

                    this.$notify.success('Dealer Account Created!');

                    this.dealer = this.dealer.toUpperCase();

                    let savedAccount = this.dealer;
                    this.$emit('saved', savedAccount);

                    this.dealer = '';
                    this.company= '';
                    this.homeBranch = '';

                }).catch(e => {

                    window.tracer.error(e);
                    this.$notify.error({
                        title: 'Server Error',
                        message: 'Failed to create dealer account '
                    });

                    this.$emit('failed');
                    window.tracer.verbose("[v389315-ADM] failed event emitted");

                });
            }
            catch(e){

                window.tracer.error(e);

                this.$notify.error({
                    title: 'Application Error',
                    message: 'Failed to create dealer account'
                });

                this.$emit('failed');
                window.tracer.verbose("[v180993-ADM] failed event emitted");
            }
        }
    }
}